export default __webpack_public_path__ + "static/media/life2.55d508c4.png";